import CliDoc from "../../../../packages/cli/readme.md";
import React from 'react';
export default {
  CliDoc,
  React
};